import { render, staticRenderFns } from "./JoiningApplicationEducationalChangePostponedStatus.vue?vue&type=template&id=63c3343a&"
import script from "./JoiningApplicationEducationalChangePostponedStatus.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationEducationalChangePostponedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports